import React from "react";
import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { ROUTES } from "@utils/constant";
import { isAuthenticated } from "@utils/utils";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { location, path, exact, computedMatch } = rest;
  const isAuthenticatedFlag = isAuthenticated();
  const paths = Object.values(ROUTES).map((o) => o.URL);

  // Get the stored paramName from location state if it exists
  const storedParamName = location?.state?.paramName;

  // If we don't have a stored param, get it from current location
  const paramName = window?.location?.href?.split("/").pop();
  const returnURL =
    window?.location?.pathname === ROUTES.LOGIN.URL
      ? storedParamName
      : paramName;

  return (
    <Route
      location={location}
      exact={exact}
      path={path}
      computedMatch={computedMatch}
      render={(props) => {
        if (isAuthenticatedFlag || paths.includes(path)) {
          return (
            <Component
              history={props.history}
              location={props.location}
              match={props.match}
              staticContext={props.staticContext}
            />
          );
        } else if (!paths.includes(path)) {
          return (
            <Redirect
              to={{
                pathname: ROUTES.ERROR_PAGE.URL,
              }}
            />
          );
        } else {
          return (
            <Redirect
              to={{
                pathname: ROUTES.LOGIN.URL,
                state: { paramName: returnURL },
              }}
            />
          );
        }
      }}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.func,
  history: PropTypes.string,
  location: PropTypes.object,
  match: PropTypes.string,
  staticContext: PropTypes.string,
};

export default PrivateRoute;
